<template>
	<div class="clothes-index__wrapper">
		<h3 class="clothes-index__title">全国の気温と服装の目安</h3>

		<div class="clothes-index__inner swiper-container" id="js_swiper">
			<ul class="clothes-index__list swiper-wrapper">
				<li class="clothes-index__item swiper-slide">
					<img class="clothes-index__item--image" :src="computedMonthImage.northernJapanImage" :alt="computedMonthImage.northernJapanAlt">
				</li>
				<li class="clothes-index__item swiper-slide">
					<img class="clothes-index__item--image" :src="computedMonthImage.westernEasternJapanImage" :alt="computedMonthImage.westernEasternJapanAlt">
				</li>
				<li class="clothes-index__item swiper-slide">
					<img class="clothes-index__item--image" :src="computedMonthImage.okinawaImage" :alt="computedMonthImage.okinawaAlt">
				</li>
			</ul>
			<div class="swiper-pagination" id="js_swiper-pagination" />
		</div>
	</div>
</template>

<script>
// ライブラリ
import Swiper from 'swiper'
import moment from 'moment'
moment.locale('ja')

export default {
	name: 'ClothesIndex',
	data () {
		return {
		}
	},
	mounted () {
		this.initSwiper()
	},
	computed: {
		// NOTE: 画像出しわけ
		computedMonthImage () {
			const month = moment().month() + 1
			const resultItem = {
				northernJapanImage: require(`@/assets/img/clothes_index/${month}_northern_japan.png`),
				northernJapanAlt: `${month}月 気温と服装の目案 北日本版`,
				westernEasternJapanImage: require(`@/assets/img/clothes_index/${month}_western_eastern_japan.png`),
				westernEasternJapanAlt: `${month}月 気温と服装の目案 東日本/西日本版`,
				okinawaImage: require(`@/assets/img/clothes_index/${month}_okinawa.png`),
				okinawaAlt: `${month}月 気温と服装の目案 沖縄版`
			}
			return resultItem
		}
	},
	methods: {
		// NOTE: Swiperの処理
		initSwiper () {
			const swiperConstructor = () => {
				return new Swiper('#js_swiper', {
					slidesPerView: 'auto',
					centeredSlides: true,
					spaceBetween: 10,
					initialSlide: 1,
					pagination: {
						el: '#js_swiper-pagination',
						type: 'bullets',
						clickable: true
					}
				})
			}
			swiperConstructor()
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~swiper/css/swiper.min.css';
@import "../../assets/sass/variable";

// NOTE: このページ限定の変数（デザインシステム外のため他での利用禁止）
$spacing-12: 0.75rem;

.clothes-index {
	width: 100%;

	&__wrapper {
		margin: $spacing-10 0;
		padding: $spacing-12 0 $spacing-10 0;
		background-color: $background-primary;
	}

	&__title {
		font-family: $family-primary;
		margin: 0 0 $spacing-10;
		padding: 0 $spacing-10;
		font-size: $font-size-16;
		color: $primary;

		&::before { content: none; }

		&::after {
			content: "";
			display: block;
			border-bottom: 2px solid $primary;
		}
	}

	&__inner {
		width: 100%;
	}

	&__list {
		margin: 0;
		padding: 0;
	}

	&__item {
		width: 260px;
		position: relative;
		list-style: none;

		&--image {
			width: 100%;
			vertical-align: middle;
		}
	}
}
.swiper-pagination {
	position: static !important;
	margin-top: $spacing-10;
}
/deep/ .swiper-pagination-bullet {
	width: 10px;
	height: 10px;
	&:nth-child(2) {
		margin: 0 $spacing-20 !important;
	}
}
/deep/ .swiper-pagination-bullet-active {
	background: $primary;
}
</style>
